var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSpace48Filled = function SvgIconSpace48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.94 20.48 11.8 5.67c.4.19.83.29 1.26.29.43 0 .86-.1 1.25-.29l11.8-5.67a2.884 2.884 0 0 0 1.64-2.61c0-1.12-.63-2.13-1.64-2.61l-11.8-5.67c-.8-.38-1.71-.38-2.51 0l-11.8 5.67a2.884 2.884 0 0 0-1.64 2.61c0 1.12.63 2.13 1.64 2.61Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24 29.18-13.12-6.3-1.47 3.06 13.33 6.4c.4.19.83.29 1.26.29.43 0 .86-.1 1.25-.29l13.33-6.4-1.47-3.06-13.12 6.3H24Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24 35.24-13.12-6.3L9.41 32l13.33 6.4c.4.19.83.29 1.26.29.43 0 .86-.1 1.25-.29l13.33-6.41-1.47-3.06-13.12 6.3.01.01Z",
    fill: "current"
  })));
};
export default SvgIconSpace48Filled;